<template lang="pug">
div.confirm-form
  div.form-group
    h4(for="expiration-date") 設定有效期限
    input.form-control.custom-input(
      type="date" 
      id="expiration-date" 
      v-model="expirationDate"
      :readonly="editable === false"
      @click="popPad"
      style="text-align: left"
    )
    DateInput(
      v-show="showPad" 
      :defaultDate="expirationDate" 
      :limitedDate="limitedDate"
      v-on:saveDate="saveDate"
      v-on:closePad="closePad"
    )
  div.button-wrap
    button.btn.btn-lg.confirm-button(
      @click="setExpirationDate"
    ) 確認
</template>

<script>
import moment from 'moment';
import DateInput from './DateInput';

export default {
  name: 'confirmExpirationDate',
  components: {
    DateInput,
  },
  props: {
    defaultExpirationDate: String,
    limitedDate: String,
    editable: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      expirationDate: '',
      showPad: false,
    };
  },
  methods: {
    setExpirationDate() {
      if (this.expirationDate !== '') {
        this.$emit('setExpirationDate', this.expirationDate);
      } else {
        this.$store.commit('SET_ERROR', { type: 'error', context: 'expiration date can not be empty.' });
      }
    },
    saveDate(val) {
      this.expirationDate = val;
      this.showPad = false;
    },
    popPad() {
      if (this.editable) this.showPad = true;
    },
    closePad() {
      this.showPad = false;
    },
  },
  created() {
    if (this.defaultExpirationDate) {
      this.expirationDate = this.defaultExpirationDate;
    } else {
      this.expirationDate = moment().add(1, 'days').toISOString().substring(0, 10);
    }
  },
};
</script>




// WEBPACK FOOTER //
// DateSelection.vue?64c32889